{
  "API_URL": "https://as-staging-api.bluefield-f4ec3dc0.swedencentral.azurecontainerapps.io",
  "AUTH0_AUDIENCE": "https://ansvar-sakerhet.production.com",
  "AUTH0_DOMAIN": "ansvarsakerhet-production.eu.auth0.com",
  "AUTH0_CLIENT_ID": "bIDWmkFu01ADcakNmEfNf2SoJwVjuHnE",
  "ENABLE_PERSONDATA_REPORT_TEXT_GENERATION": true
}
